'use client';
// ScriptBasedComponent.jsx
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

let scriptLoadingPromise;

const loadExternalScriptOnce = (src) => {
  if (!scriptLoadingPromise) {
    scriptLoadingPromise = new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => reject(false);
      document.body.appendChild(script);
    });
  }

  return scriptLoadingPromise;
};

export const ScriptBound = ({
  scriptSrc,
  children,
  loadScriptOnce,
  scriptLoadCallback,
}: {
  scriptSrc: string;
  children: React.ReactNode;
  loadScriptOnce?: boolean;
  scriptLoadCallback?: () => void;
}) => {
  const [scriptReady, setScriptReady] = useState(false);

  useEffect(() => {
    // console.log('Loading script:', scriptSrc);
    if (Platform.OS === 'web') {
      loadExternalScriptOnce(scriptSrc)
        .then((loadResult: boolean) => {
          if (loadResult) {
            scriptLoadCallback?.();
            setScriptReady(loadResult);
          }
        })
        .catch((err) => console.error(err));
    }
  }, []);

  if (!scriptReady && Platform.OS === 'web') return null; // Or a loader/spinner if desired

  // console.log('Script loaded:', scriptSrc);

  return <>{children}</>;
};
